/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { connect } from 'react-redux';
import { getErrors, passTypesSelectors, validationSelectors } from '../reducers';
import PassSelectionError from '../components/PassSelectionError';

function mapStateToProps(state) {
    const errors = getErrors(state, 'reservations', 'facilities', 'passTypes');
    const validationErrors = validationSelectors.getValidationErrors(state);
    if (validationErrors.length) {
        errors.validation = validationErrors;
    }
    return {
        validationErrors: validationSelectors.getValidationProblems(state),
        passTypes: passTypesSelectors.getPassTypes(state),
        errors,
    };
}

export default connect(mapStateToProps)(PassSelectionError);
